import React from 'react'
import Button from '@/primitives/Button'
import Strings from '../../../../Strings'
import Box from '@/primitives/Box'
import './DateFilterButton.scss'

const DateFilterButton = ({
  onClick,
  currentDateFilter,
  dateFiltersSynced
}) => {
  const strings = Strings()
  const dateRange = currentDateFilter?.dateRange
    ? strings[currentDateFilter.dateRange]
    : ''

  return (
    <Box className='DateFilterContainer'>
      <Button
        variant='primary'
        iconBefore='calendar_month'
        onClick={onClick}
        className='DateFilterButton'
      >
        <Box as='span' className='ButtonLabel'>
          {strings.dateFilter}
        </Box>
        <Box as='span' className='DateRangeIndicator'>
          {dateRange}
        </Box>
        {dateFiltersSynced && (
          <Box as='span' className='SyncDateIndicator'>
            {strings.synced}
          </Box>
        )}
      </Button>
    </Box>
  )
}

export default DateFilterButton
